var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Stack, Typography } from "@mui/material";
import AppBarHeader from "../components/Home/AppBarHeader";
import { CategorySection } from "../components/Home/CategorySection";
import { HomeTabs } from "../components/Home/HomeTabs";
import { Search } from "../components/Home/Search";
import { SearchSection } from "../components/Home/SearchSection";
import { NaoEncontrado } from "../components/NaoEncontrado";
import { allCategories } from "../util/categorias";
export var Home = function () {
    var navigate = useNavigate();
    var _a = useParams(), search = _a.search, category = _a.category;
    var _b = useState(), inputSearch = _b[0], setInputSearch = _b[1];
    var _c = useState(), searchResults = _c[0], setSearchResults = _c[1];
    var _d = useState(0), selectedCategoryId = _d[0], setSelectedCategoryId = _d[1];
    var _e = useState(allCategories.find(function (c) { return c.id === selectedCategoryId; })), selectedCategory = _e[0], setSelectedCategory = _e[1];
    var onlyServices = allCategories.flatMap(function (category) { return category.services; });
    var verifySearchInput = function () {
        if (search && search !== "undefined") {
            return search;
        }
        return "";
    };
    useEffect(function () {
        localStorage.removeItem("pidRequestData");
    }, []);
    useEffect(function () {
        if (category) {
            setSelectedCategoryId(Number(category));
            setSelectedCategory(allCategories.find(function (c) { return c.id === Number(category); }));
        }
        else {
            setSelectedCategory(allCategories.find(function (c) { return c.id === selectedCategoryId; }));
        }
    }, [selectedCategoryId, category]);
    useEffect(function () {
        if (inputSearch) {
            var result = onlyServices.filter(function (service) {
                return service.title.toLowerCase().includes(inputSearch.toLowerCase());
            });
            setSearchResults(result);
        }
        if (search && search !== "undefined") {
            var result = onlyServices.filter(function (service) {
                return service.title.toLowerCase().includes(search.toLowerCase());
            });
            setSearchResults(result);
            setInputSearch(search);
        }
    }, [inputSearch, search]);
    return (_jsxs("div", __assign({ style: { width: "100%" } }, { children: [_jsxs(Stack, __assign({ sx: {
                    position: "fixed",
                    top: 0,
                    left: 0,
                    right: 0,
                    zIndex: 1000,
                    backgroundColor: "white",
                } }, { children: [_jsx(AppBarHeader, { titulo: "DETRAN MT - Portal de Servi\u00E7os", isHome: true }), _jsxs(Stack, __assign({ mt: "-8rem", gap: "1rem", justifyContent: "center", alignItems: "center" }, { children: [_jsx(Search, { text: inputSearch !== null && inputSearch !== void 0 ? inputSearch : verifySearchInput(), onSearch: function (value) { return setInputSearch(value); }, onClearSearch: function () {
                                    setInputSearch(undefined);
                                    setSearchResults(undefined);
                                    navigate("/home");
                                } }), _jsx(HomeTabs, { selectedCategory: selectedCategoryId, changeCategory: function (value) { return setSelectedCategoryId(value); } })] }))] })), _jsxs(Stack, __assign({ sx: {
                    paddingTop: "16rem",
                } }, { children: [_jsx(Stack, __assign({ my: { md: "6rem", xs: "9rem" } }, { children: (!searchResults || searchResults.length === 0) &&
                            !inputSearch &&
                            selectedCategory && _jsx(CategorySection, { category: selectedCategory }) })), _jsxs(Stack, __assign({ mt: { md: "-15rem", xs: "-18rem" }, justifyContent: "center", alignItems: "start", px: { md: "20%", xs: "5%" }, gap: "1rem" }, { children: [inputSearch && (_jsxs(Typography, __assign({ variant: "h6", fontWeight: 400 }, { children: ["Resultados para:", " ", _jsx("span", __assign({ style: { fontWeight: 500 } }, { children: inputSearch }))] }))), searchResults && searchResults.length > 0 && (_jsx(SearchSection, { searchResults: searchResults })), searchResults && searchResults.length === 0 && (_jsx(Stack, __assign({ width: "100%" }, { children: _jsx(NaoEncontrado, { subtitulo: "N\u00E3o foi encontrado nenhum servi\u00E7o com os termos de busca fornecidos", noMargin: true }) })))] }))] }))] })));
};
